/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\EmailTemplatesActions.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the email-templates module.
----------------------------------------------------------------*/

import React from 'react';
import { Edit, Copy, Trash2 } from 'lucide-react';
import { useI18n } from '@/hooks/useI18n';
import { EmailTemplate } from '../api/emailTemplatesApi';
import { SimpleTooltip } from '@/components/ui/SimpleTooltip';

interface EmailTemplatesActionsProps {
    template: EmailTemplate;
    onEdit: (template: EmailTemplate) => void;
}

export function EmailTemplatesActions({
    template,
    onEdit,
}: EmailTemplatesActionsProps) {
    const { t } = useI18n();

    return (
        <div className="flex items-center gap-1.5 justify-end">
            <SimpleTooltip content={t('common.edit')} position="top">
                <button
                    type="button"
                    onClick={() => onEdit(template)}
                    className="p-2 text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-blue-900/20 rounded transition-colors"
                >
                    <Edit className="h-4 w-4" />
                </button>
            </SimpleTooltip>
        </div>
    );
}
